
/**
 * SEO 配置 - models (ภาษาไทย)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 เครื่องสร้างวิดีโอ AI | WeryAI',
        description: 'สร้างวิดีโอ AI ที่สมจริงและแม่นยำตามหลักฟิสิกส์ด้วย OpenAI Sora 2 พร้อมเสียงที่ซิงโครไนซ์และความต่อเนื่องของเรื่องราวแบบหลายช็อต',
        keywords: 'Sora 2, OpenAI Sora, โมเดลวิดีโอ AI, วิดีโอสมจริง, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - ตัวสร้างภาพ AI ดั้งเดิม | WeryAI',
        description: 'ใช้ WeryAI Image 2 สร้างภาพ AI ดั้งเดิมสุดอลังการ! โมเดลเรือธงควบคุมสไตล์ขั้นสูง เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'WeryAI Image 2, ตัวสร้างภาพ AI ดั้งเดิม, ภาพ AI เรือธง, คุณภาพสตูดิโอ AI, WeryAI Image ฟรี, วิธีใช้ WeryAI Image 2, WeryAI',
    },
    image_grok_2: {
        title: 'ฟรี Grok 2 - ตัวสร้างภาพ xAI | WeryAI',
        description: 'ใช้ Grok 2 บน WeryAI สร้างภาพ AI สร้างสรรค์! โมเดล xAI มีความยืดหยุ่นทางศิลปะ เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'Grok 2, Grok AI, ตัวสร้างภาพ xAI, ศิลปะ AI, ภาพ AI สร้างสรรค์, Grok 2 ฟรี, วิธีใช้ Grok 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 เครื่องสร้างภาพ โมเดล AI | WeryAI',
        description: 'Nano Banana 2 ขับเคลื่อนด้วย Gemini พร้อมความรู้ระดับโลกและการค้นหาแบบเรียลไทม์ สร้างภาพที่ถูกต้องตามข้อเท็จจริงและสวยงามด้วยความเร็วสูงสุด',
        keywords: 'Nano Banana 2, Google AI, Gemini, สร้างภาพ, เรนเดอร์ข้อความ, ความสอดคล้องหลายวัตถุ, 4K, WeryAI',
        og_title: 'เครื่องมือสร้างภาพ Nano Banana 2 | WeryAI',
        og_description: 'Nano Banana 2 ขับเคลื่อนด้วย Gemini พร้อมความเข้าใจโลกอย่างลึกซึ้งและการค้นหาแบบเรียลไทม์ สร้างภาพที่สวยงามและถูกต้องตามข้อเท็จจริง',
        twitter_title: 'เครื่องมือสร้างภาพ Nano Banana 2 | WeryAI',
        twitter_description: 'Nano Banana 2 ขับเคลื่อนด้วย Gemini พร้อมความเข้าใจโลกอย่างลึกซึ้งและการค้นหาแบบเรียลไทม์ สร้างภาพที่สวยงามและถูกต้องตามข้อเท็จจริง',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'เครื่องสร้างภาพ AI Nano Banana 2',
        twitterImageAlt: 'เครื่องสร้างภาพ AI Nano Banana 2',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo เครื่องสร้างวิดีโอ AI ระดับภาพยนตร์ | WeryAI',
        description: 'Kling 2.5 Turbo สร้างวิดีโอ AI ระดับภาพยนตร์พร้อมการควบคุมเลนส์ขั้นสูง การแสดงออกทางอารมณ์ และการเคลื่อนไหวที่ลื่นไหล',
        keywords: 'Kling 2.5 Turbo, Kling AI, วิดีโอ AI ระดับภาพยนตร์, การควบคุมเลนส์, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 เครื่องมือสร้างและตัดต่อวิดีโอ AI | WeryAI',
        description: 'Runway Gen-4 สร้างวิดีโอ AI ที่สมจริงและสม่ำเสมอ พร้อมการเข้าใจพรอมป์ต์เชิงลึกและเครื่องมือตัดต่ออัจฉริยะ ลองใช้ฟรีบน WeryAI',
        keywords: 'Runway Gen-4, Runway AI, ตัวสร้างวิดีโอ AI, ข้อความเป็นวิดีโอ, ภาพเป็นวิดีโอ, ตัดต่อวิดีโอ AI, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI Video Generator - การสร้างวิดีโอขั้นสูง | WeryAI',
        description: 'สร้างวิดีโอ AI ขั้นสูงด้วย Hailuo AI บน WeryAI มาพร้อมการควบคุมการเคลื่อนไหวระดับแนวหน้าและการเรนเดอร์ฉากที่สมจริง。',
        keywords: 'Hailuo AI, MiniMax, เครื่องสร้างวิดีโอ AI, การควบคุมการเคลื่อนไหว, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'เครื่องมือสร้างวิดีโอ Seedance AI | WeryAI',
        description: 'เครื่องมือสร้างวิดีโอ Seedance AI - การสร้างท่าเต้นและท่าทาง on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - ตัวสร้างวิดีโอ AI ระดับผู้กำกับ | WeryAI',

        description: 'สร้างวิดีโอ AI ระดับผู้กำกับด้วย Werydance 2.0: อ้างอิงหลายรูปแบบ ความสม่ำเสมอของเรื่องราว และจำลองฟิสิกส์ ฟรีบน WeryAI。',

        keywords: 'Werydance 2.0, Seedance AI, weryai, ตัวสร้างวิดีโอ AI, วิดีโอระดับผู้กำกับ, วิดีโอหลายรูปแบบ, จำลองฟิสิกส์, ซิงค์ริมฝีปาก, ข้อความเป็นวิดีโอ, วิดีโอ AI ฟรี, WeryAI',

        og_title: 'Werydance 2.0 - ตัวสร้างวิดีโอ AI ระดับผู้กำกับ | WeryAI',

        og_description: 'สร้างวิดีโอ AI ระดับผู้กำกับด้วย Werydance 2.0: อ้างอิงหลายรูปแบบ ความสม่ำเสมอของเรื่องราว และจำลองฟิสิกส์ ฟรีบน WeryAI。',

        twitter_title: 'Werydance 2.0 - ตัวสร้างวิดีโอ AI ระดับผู้กำกับ | WeryAI',

        twitter_description: 'สร้างวิดีโอ AI ระดับผู้กำกับด้วย Werydance 2.0: อ้างอิงหลายรูปแบบ ความสม่ำเสมอของเรื่องราว และจำลองฟิสิกส์ ฟรีบน WeryAI。',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    image_nano_banana_pro: {
        title: 'ฟรี Nano Banana Pro - ตัวสร้างภาพ AI | WeryAI',
        description: 'ใช้ Nano Banana Pro บน WeryAI ภาพ AI คุณภาพสูงสุด! เทียบเท่า Midjourney ในคุณภาพ เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google ภาพ AI, ภาพ AI เชิงเหตุผล, 4K ภาพ AI, Nano Banana Pro ฟรี, วิธีใช้ Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: 'ฟรี Nano Banana - ตัวสร้างภาพ AI | WeryAI',
        description: 'ใช้ Nano Banana บน WeryAI สร้างภาพ AI ง่ายๆ! โมเดล AI อเนกประสงค์และรวดเร็ว เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google ภาพ AI, ตัวสร้าง AI เร็ว, ความสม่ำเสมอตัวละคร, Nano Banana ฟรี, วิธีใช้ Nano Banana, WeryAI',
    },
    image_flux: {
        title: 'ฟรี FLUX - ลองใช้ตัวสร้างภาพ AI | WeryAI',
        description: 'ใช้ FLUX บน WeryAI สร้างภาพ AI สุดอลังการ! สร้างโดยทีม Stable Diffusion คุณภาพภาพยอดเยี่ยม เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, ตัวสร้างภาพ AI, ข้อความเป็นภาพ, ศิลปะ AI, FLUX ฟรี, วิธีใช้ FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: 'ฟรี FLUX Kontext - โปรแก้ไขภาพ AI | WeryAI',
        description: 'ใช้ FLUX Kontext บน WeryAI สำหรับการแก้ไขภาพ AI ระดับมืออาชีพ! ความแม่นยำสูง, ตัวอักษรขั้นสูง เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, โปรแก้ไขภาพ AI, ภาพ AI โปร, ตัวอักษร AI, FLUX Kontext ฟรี, วิธีใช้ FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: 'ฟรี Imagen 4 - ตัวสร้างภาพ AI จาก Google | WeryAI',
        description: 'ใช้ Google Imagen 4 บน WeryAI สร้างภาพ AI สมจริง! ควบคุมสไตล์หลากหลายและสร้างข้อความแม่นยำ เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'Imagen 4, Google Imagen, ตัวสร้างภาพ AI Google, ข้อความเป็นภาพ, AI สมจริง, Imagen ฟรี, วิธีใช้ Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: 'ฟรี Qwen Image - โมเดลภาพ AI จาก Alibaba | WeryAI',
        description: 'ใช้ Qwen Image บน WeryAI สร้างศิลปะ AI หลายภาษา! โมเดลโอเพนซอร์สจาก Alibaba เรนเดอร์ข้อความเหนือชั้น เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'Qwen Image, Alibaba AI, ภาพ AI โอเพนซอร์ส, เรนเดอร์ข้อความหลายภาษา, Qwen Image ฟรี, วิธีใช้ Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: 'ฟรี Wan AI - ตัวสร้างภาพ Alibaba | WeryAI',
        description: 'ใช้ Wan AI บน WeryAI สำหรับภาพ AI ความสมจริงสูง! โมเดล Alibaba ตามคำสั่งแม่นยำและเรนเดอร์สมจริง เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'Wan AI, Wan 2.5, ตัวสร้างภาพ AI Alibaba, ข้อความเป็นภาพ, AI สมจริง, Wan AI ฟรี, วิธีใช้ Wan AI, WeryAI',
    },
    image_seendream: {
        title: 'ฟรี Seedream 4.0 - ByteDance ภาพ AI | WeryAI',
        description: 'ใช้ Seedream 4.0 บน WeryAI สร้างภาพ AI เร็วสุด! โมเดล ByteDance สไตล์ศิลปะหลากหลาย เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'Seedream, Seedream 4.0, ByteDance ภาพ AI, ภาพ AI เร็วสุด, สไตล์ศิลปะ AI, Seedream ฟรี, วิธีใช้ Seedream, WeryAI',
    },
    image_dreamina: {
        title: 'ฟรี Dreamina 4.0 - AI ภาพหลายรูปแบบ | WeryAI',
        description: 'ใช้ Dreamina 4.0 บน WeryAI สร้างภาพ AI หลายรูปแบบ! ร่างเป็นภาพ ถ่ายโอนสไตล์ รวมตัวละคร เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'Dreamina 4.0, ByteDance ภาพ AI, ภาพ AI หลายรูปแบบ, ร่างเป็นภาพ, ถ่ายโอนสไตล์, Dreamina ฟรี, วิธีใช้ Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - โมเดลสร้างภาพ AI ชั้นนำของ ByteDance | WeryAI',
        description: 'Seedream 4.5 เป็นโมเดลภาพ AI ชั้นนำล่าสุดของ ByteDance เน้นการเรนเดอร์ตัวอักษรที่แม่นยำและการรวมหลายภาพพร้อมเอาต์พุต 4K Ultra HD ทดลองใช้ฟรีบน WeryAI。',
        keywords: 'Seedream 4.5, การสร้างภาพ AI, การเรนเดอร์ตัวอักษร, การรวมภาพ, ByteDance, คุณภาพ 4K, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 โมเดลสร้างภาพ AI ระดับสูงสุดของ | WeryAI',
        description: 'Seedream 5.0 เป็นผลงานชิ้นเอกของ ByteDance ในด้าน AI ภาพ ด้วยคุณภาพ 8K ดั้งเดิม ความเข้าใจเชิงความหมายขั้นสูงสุด การจัดองค์ประกอบหลายวัตถุ และการเรนเดอร์ข้อความ 2.0 ทดลองใช้ฟรีบน WeryAI',
        keywords: 'Seedream 5.0, การสร้างภาพ AI, คุณภาพ 8K, ความเข้าใจเชิงความหมาย, การจัดองค์ประกอบหลายวัตถุ, การเรนเดอร์ข้อความ, ByteDance, WeryAI',
        og_title: 'เครื่องสร้างภาพ Seedream 5.0 | WeryAI',
        og_description: 'Seedream 5.0 เป็นผลงานชิ้นเอกของ ByteDance ในด้าน AI ภาพ ด้วยคุณภาพ 8K ดั้งเดิม ความเข้าใจเชิงความหมายขั้นสูงสุด การจัดองค์ประกอบหลายวัตถุ และการเรนเดอร์ข้อความที่แม่นยำ ทดลองฟรีบน WeryAI',
        twitter_title: 'เครื่องสร้างภาพ Seedream 5.0 | WeryAI',
        twitter_description: 'Seedream 5.0 เป็นผลงานชิ้นเอกของ ByteDance ในด้าน AI ภาพ ด้วยคุณภาพ 8K ดั้งเดิม ความเข้าใจเชิงความหมายขั้นสูงสุด การจัดองค์ประกอบหลายวัตถุ และการเรนเดอร์ข้อความที่แม่นยำ ทดลองฟรีบน WeryAI',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'เครื่องสร้างภาพ AI Seedream 5.0',
        twitterImageAlt: 'เครื่องสร้างภาพ AI Seedream 5.0',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - เครื่องมือสร้างกราฟิกเวกเตอร์ AI ระดับมืออาชีพ | WeryAI',
        description: 'Recraft V4 Vector เป็นเครื่องมือสร้างกราฟิกเวกเตอร์ AI ระดับมืออาชีพจาก Recraft.ai ที่สร้างเวกเตอร์ SVG ที่แก้ไขได้พร้อมการปรับขนาดแบบไม่สูญเสียคุณภาพ การจัดวางตัวอักษรที่แม่นยำ และการควบคุมสไตล์แบรนด์ ทดลองใช้ฟรีบน WeryAI ตอนนี้',
        keywords: 'Recraft V4 Vector, การสร้างเวกเตอร์ AI, เครื่องมือสร้าง SVG, เวกเตอร์แท้, การออกแบบโลโก้, ไอคอน UI, ภาพประกอบเวกเตอร์, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'ฟรี Midjourney - ลองใช้ตัวสร้างศิลปะ AI | WeryAI',
        description: 'ใช้ Midjourney บน WeryAI สร้างภาพ AI ศิลปะ! มีชื่อเสียงด้านสุนทรียศาสตร์และคุณภาพแสง เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'Midjourney, Midjourney AI, ตัวสร้างศิลปะ AI, ภาพ AI ศิลปะ, Midjourney ฟรี, ทางเลือก Midjourney, วิธีใช้ Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 เครื่องมือสร้างวิดีโอ AI | WeryAI',
        description: 'สร้างวิดีโอที่น่าทึ่งด้วย Runway Gen-4.5 บน WeryAI สถาปัตยกรรมไฮบริดออโตรีเกรสซีฟ-ดิฟฟิวชันสำหรับการจำลองฟิสิกส์ที่แม่นยำและความสอดคล้องทางเวลา',
        keywords: 'Runway Gen-4.5, เครื่องมือสร้างวิดีโอ AI, วิดีโอ AI ระดับภาพยนตร์, การจำลองฟิสิกส์, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro เครื่องมือสร้างวิดีโอ AI | WeryAI',
        description: 'สร้างวิดีโอคุณภาพสูงด้วย Kling 2.6 Pro บน WeryAI การสร้างเสียงและภาพดั้งเดิม คุณภาพภาพยนตร์ 1080p การปฏิบัติตามพรอมต์ที่ยอดเยี่ยม',
        keywords: 'Kling 2.6 Pro, เครื่องมือสร้างวิดีโอ AI, วิดีโอ AI คุณภาพสูง, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 เครื่องมือสร้างวิดีโอ | WeryAI',
        description: 'สร้างวิดีโอ AI ระดับภาพยนตร์ด้วย Dreamina 3.0 (Jimeng 3.0) บน WeryAI การควบคุมเฟรมเริ่มต้น/สิ้นสุดที่แม่นยำ การเคลื่อนไหวกล้องระดับมืออาชีพ และการสร้างวิดีโอ 1080p ไดนามิกสูง',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, เครื่องมือสร้างวิดีโอ AI, การควบคุมกล้อง, เฟรมเริ่มต้นสิ้นสุด, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 เครื่องมือสร้างวิดีโอ AI | WeryAI',
        description: 'ปลดปล่อยความคิดสร้างสรรค์ของคุณบน WeryAI ด้วยเครื่องมือสร้างวิดีโอ AI Kling O1 เหมาะสำหรับการสร้างเนื้อหาวิดีโอที่มีจินตนาการและไม่ซ้ำใคร',
        keywords: 'Kling O1, เครื่องมือสร้างวิดีโอ AI, วิดีโอ AI สร้างสรรค์, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - ตัวสร้างวิดีโอ AI อัจฉริยะ | WeryAI',

        description: 'สร้างวิดีโอ AI ด้วย Kling 3.0: สตอรี่บอร์ดอัจฉริยะ ซิงค์ริมฝีปากหลายภาษา และเรนเดอร์ข้อความแม่นยำ ทดลองฟรีบน WeryAI。',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, ตัวสร้างวิดีโอ AI, สตอรี่บอร์ดอัจฉริยะ, ซิงค์ริมฝีปาก, เรนเดอร์ข้อความ, ข้อความเป็นวิดีโอ, ภาพเป็นวิดีโอ, วิดีโอ AI ฟรี, WeryAI',

        og_title: 'Kling 3.0 - ตัวสร้างวิดีโอ AI อัจฉริยะ | WeryAI',

        og_description: 'สร้างวิดีโอ AI ด้วย Kling 3.0: สตอรี่บอร์ดอัจฉริยะ ซิงค์ริมฝีปากหลายภาษา และเรนเดอร์ข้อความแม่นยำ ทดลองฟรีบน WeryAI。',

        twitter_title: 'Kling 3.0 - ตัวสร้างวิดีโอ AI อัจฉริยะ | WeryAI',

        twitter_description: 'สร้างวิดีโอ AI ด้วย Kling 3.0: สตอรี่บอร์ดอัจฉริยะ ซิงค์ริมฝีปากหลายภาษา และเรนเดอร์ข้อความแม่นยำ ทดลองฟรีบน WeryAI。',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - เสียงและวิดีโอดั้งเดิม 16 วินาที AI | WeryAI',

        description: 'สร้างเสียงและวิดีโอดั้งเดิม 16 วินาทีด้วย Vidu Q3: ตัดอัจฉริยะ เรนเดอร์ข้อความแม่นยำ และซิงค์ริมฝีปากหลายภาษา ฟรีบน WeryAI。',

        keywords: 'Vidu Q3, Vidu AI, ตัวสร้างวิดีโอ AI, เสียงและวิดีโอดั้งเดิม 16 วินาที, สตอรี่บอร์ดอัจฉริยะ, เรนเดอร์ข้อความ, ซิงค์ริมฝีปาก, ข้อความเป็นวิดีโอ, วิดีโอ AI ฟรี, WeryAI',

        og_title: 'Vidu Q3 - เสียงและวิดีโอดั้งเดิม 16 วินาที AI | WeryAI',

        og_description: 'สร้างเสียงและวิดีโอดั้งเดิม 16 วินาทีด้วย Vidu Q3: ตัดอัจฉริยะ เรนเดอร์ข้อความแม่นยำ และซิงค์ริมฝีปากหลายภาษา ฟรีบน WeryAI。',

        twitter_title: 'Vidu Q3 - เสียงและวิดีโอดั้งเดิม 16 วินาที AI | WeryAI',

        twitter_description: 'สร้างเสียงและวิดีโอดั้งเดิม 16 วินาทีด้วย Vidu Q3: ตัดอัจฉริยะ เรนเดอร์ข้อความแม่นยำ และซิงค์ริมฝีปากหลายภาษา ฟรีบน WeryAI。',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_4o: {
        title: 'ฟรี GPT-4o - ตัวสร้างภาพ OpenAI | WeryAI',
        description: 'ใช้ GPT-4o บน WeryAI สร้างภาพผ่านการสนทนา! AI ของ OpenAI เรนเดอร์ข้อความแม่นยำและผลลัพธ์คุณภาพสูง เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'GPT-4o, GPT-4o ภาพ, ตัวสร้างภาพ OpenAI, ศิลปะ AI สนทนา, GPT-4o ฟรี, วิธีใช้ GPT-4o ภาพ, WeryAI',
    },
    image_gpt_image_1_5: {
        title: 'ฟรี GPT Image 1.5 - ตัวสร้างศิลปะ OpenAI | WeryAI',
        description: 'ใช้ GPT Image 1.5 บน WeryAI สำหรับศิลปะ AI รุ่นใหม่! โมเดลล่าสุดของ OpenAI สร้างสรรค์และรายละเอียดดีขึ้น เครดิตฟรี ไม่ต้องใช้บัตร',
        keywords: 'GPT Image 1.5, โมเดลภาพ OpenAI, ตัวสร้างศิลปะ AI, AI รุ่นใหม่, GPT Image 1.5 ฟรี, วิธีใช้ GPT Image 1.5, WeryAI',
    },
}
